export default __webpack_public_path__ + "3c9a9829c4e7f9286c600630a899affc.png";